<template>
  <div id="Home" class="Home">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      innerStyle: { width: 0, height: 0 },
    };
  },
  created() {},
  mounted() {
    this.viewinHW();
  },
  methods: {
    viewinHW() {
      this.innerStyle.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.innerStyle.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      this.$store.dispatch('setInnerWHFun', this.innerStyle);
      let that = this;
      window.addEventListener('resize', (e) => {
        that.innerStyle.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        that.innerStyle.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        that.$store.dispatch('setInnerWHFun', that.innerStyle);
      });
      // window.onresize = (e) => {
      //   that.innerStyle.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      //   console.log('🚀 ~ that.innerStyle:', that.innerStyle);
      //   that.innerStyle.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      //   that.$store.dispatch('setInnerWHFun', that.innerStyle);
      // };
    },
  },
  components: {},
};
</script>
<style lang="less">
#Home {
  height: calc(100vh - 60px);
  font-size: 16px;

  // /*隐藏滚轮*/
  // ::-webkit-scrollbar {
  //   display: none;
  // }
}
.Home {
  /*隐藏滚轮*/
  // ::-webkit-scrollbar {
  //   // display: none;
  //   // 使用height不用display（为了适配el-table横向滚动条）
  //   height: 0px;
  // }
}
.el-message {
  z-index: 999999 !important;
}

.el-message-box {
  width: auto !important;
}
</style>
<style scoped></style>
